export const smallGridSpacing = 2
export const gridSpacing = 3
export const drawerWidth = 260
export const appDrawerWidth = 320
